import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const EMPLOYEE_ATTACHMENTS_QUERY_KEY = ["employee-attachments"];
export const VIEW_EMPATTACHMENTS_QUERY_KEY = ["view-employee-attachments"];

export const employeeAttachmentsService = {
  uploadAttachment: async (payload: FormData) => {
    return api.post(`api/employee-attachments`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  viewEmployeeAttachment: async (emp_no: string) => {
    const response = await api.get(
      `api/view-employee-attachments/${emp_no}`,
    );
    return response.data;
  },
  downloadAttachment: async (file_path: string) => {
     return api.get(
      `api/employee-attachments/download/${file_path}`,
      {
        responseType: "blob",
      }
    );
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/employee-attachments/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  updateAttachment: async (
    id: number,
    category_id: number,
  ) => {
    const response = await api.patch(
      `api/employee-attachments/${id}`,
      {
        category_id,
      }
    );
    return response.data;
  },
};
